import { WhichWeightAPI } from 'WhichWeightAPI';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setOrganizationGroups } from 'redux/slices/organization';

export const useGetGroups = () => {
    
    const dispatch = useDispatch();

    const userId = useSelector(state => state.user.id);
    const organizationId = useSelector(state => state.user.organizationId);
    const cachedGroups = useSelector(state => state.organization.groups);

    const [groups, setGroups] = useState(cachedGroups);

    const FetchGroupsFromBackend = async () => {
        const jsonBody = {
            userId: userId,
            organizationId: organizationId
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('REPORTING', 'GET', '/groups', jsonBody)

        // console.log(result)

        if (result.data.status === 'failure') {
            console.error(result.data)
            dispatch(setOrganizationGroups([]));
            setGroups([]);
            return
        }

        dispatch(setOrganizationGroups(result.data.data));

        setGroups(result.data.data);
    }

    useEffect(() => {
        if (userId === null) return;
        if (organizationId === null) return;

        if (cachedGroups === null) {
            FetchGroupsFromBackend();
        } 
        
        // Make sure any changes to the redux store directly get updated
        if (cachedGroups !== null) {
            setGroups(cachedGroups);
        }
    }, [cachedGroups, dispatch]);

    return groups;
};